type RightSideContentWrapperProps = {
  topHeightFlinch?: string;
};

const RightSideContentWrapper: React.FC<RightSideContentWrapperProps> = ({
  children,
  topHeightFlinch,
}) => {
  return (
    <div
      style={{
        maxHeight: `calc(100vh - ${topHeightFlinch || '100px'})`,
        overflow: 'auto',
      }}>
      {children}
    </div>
  );
};

export default RightSideContentWrapper;
